import React, { Component } from 'react';

import { Helmet } from 'react-helmet';
import intersection from 'lodash.intersection';

import Filters from './Filters';
import BuildingBar from './BuildingBar';
import TableOptions from './TableOptions';
import RightMenu from './RightMenu';
import Table from './Table';
import List from './List';
import Loader from 'components/common/Loader/Loader';
import { parseQuery, compileQuery, formatNumber } from 'utils';
import getApartments from 'constants/apartments';
import getInteriors from 'constants/interiors';

// import iconClock from 'assets/images/icons/icon-clock.svg';
import IconRight from 'assets/images/icons/arrow-right-gray.svg';

import cn from 'classnames';
import styles from './Chess.scss';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  loadBuilding,
  loadPavilions,
  loadChess,
  setCells,
  setFilters,
  setZoom,
  setChessTable,
  setChessExtended,
  setChessDescriptionHide,
  setListSort,
  setTableScroll,
  setSelected,
  setPrevLocation,
  updateChessState,
} from 'actions/building';
import tracker from '../../../services/tracker';
import { withTranslation } from 'react-i18next';
import { isReserved } from '../../../helper';
import { gaEvent, trackGA } from 'services/ga';

const MIN_SCALE = 0.5;
const MAX_SCALE = 2;

class Chess extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSidebarHidden: false,
    };

    this.handleListClick = this.handleListClick.bind(this);
    this.handleExtendedClick = this.handleExtendedClick.bind(this);
    this.handleListSort = this.handleListSort.bind(this);
    this.handleFilters = this.handleFilters.bind(this);
    this.handleTableScroll = this.handleTableScroll.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.filteredIntersection = null;
  }

  UNSAFE_componentWillMount() {
    const {
      building: { pavilions },
      updateChessState,
      location,
    } = this.props;
    const { search } = this.props;

    const params = this.parseQuery(location.search);
    const { fromBuilding, ...restParams } = params;
    if (search && search.request) {
      const savedFilters = {
        minPrice: search.request.minPrice || null,
        maxPrice: search.request.maxPrice || null,
        minCost: search.request.minCost || null,
        maxCost: search.request.maxCost || null,
        areaFrom: search.request.areaFrom || null,
        areaTo: search.request.areaTo || null,
      };

      this.transitionTo(savedFilters);

      if (fromBuilding) {
        updateChessState(Object.assign({}, restParams, savedFilters));
      } else {
        updateChessState(Object.assign({}, savedFilters, restParams));
      }
    } else {
      updateChessState(restParams);
    }

    if (!pavilions) {
      const { loadPavilions, match } = this.props;
      loadPavilions(match.params.id);
    }
    if (!this.props.print) {
      document.body.classList.toggle('chess', true);
    }
  }

  componentDidMount() {
    this.prepareChess(this.props, true);

    trackGA(
      gaEvent.pageShow({
        screenName: this.props.location.pathname,
      })
    );
  }

  prepareChess(props, initial = false) {
    if (!props.building.isLoading || !props.isObjectsFetching) {
      const { location } = props;
      const { location: prevLocation } = this.props;
      if (location !== prevLocation) {
        const { updateChessState } = this.props;
        const params = this.parseQuery(location.search);
        updateChessState(params);
        return;
      }

      const {
        building: { pavilions },
      } = props;

      if (pavilions) {
        const {
          building: {
            chessList,
            cells,
            filters: { section: selectedSectionPath },
          },
          t,
        } = props;
        const selectedSectionKey = selectedSectionPath.join('.');
        const [pavilionId, sectionId] = selectedSectionPath;
        const selectedSectionId = pavilions[pavilionId].sections[sectionId].id;
        const chess = chessList[selectedSectionId];
        const filtersChanged =
          JSON.stringify(this.props.building.filters) !== JSON.stringify(props.building.filters);
        const { isChessLoading } = props.building;
        if (!isChessLoading || filtersChanged || this.props.print) {
          const { loadChess } = props;
          const updateCells = (resp) => {
            const { setCells } = props;
            let { rows, cols, cells } = resp.data.data;
            rows = rows || [];
            cols = cols || [];
            cells = cells || [];
            const { data, selected } = this.getData(rows, cols, cells, t);
            setCells(selectedSectionKey, data, selected);
          };

          let filteredIntersection = null;
          // FIXME: убрать это и вынести отсюда
          if (chess) {
            const interiorsInHouse = chess.cells.reduce((list, cell) => {
              if (
                cell.data.status === 'saleStatus' ||
                isReserved(cell.data.status) ||
                cell.data.status === 'assignmentStatus'
              ) {
                return list.includes(cell.data.interior) ? list : [cell.data.interior, ...list];
              }
              return list;
            }, []);
            const splitedInterior =
              props.building.filters.interior && props.building.filters.interior.length
                ? props.building.filters.interior.split(',')
                : [];
            const interiorIntersection = intersection(interiorsInHouse, splitedInterior);
            filteredIntersection = interiorIntersection.length
              ? interiorIntersection.join(',')
              : null;
          }

          if (
            initial ||
            !chess ||
            filtersChanged ||
            this.filteredIntersection !== filteredIntersection
          ) {
            this.filteredIntersection = filteredIntersection;

            loadChess({
              id: selectedSectionId,
              costMin: props.building.filters.costMin,
              costMax: props.building.filters.costMax,
              priceMin: props.building.filters.priceMin,
              priceMax: props.building.filters.priceMax,
              areaFrom: props.building.filters.areaFrom,
              areaTo: props.building.filters.areaTo,
              stock: filteredIntersection,
              view_type: props.building.filters.view_type,
            }).then(updateCells);
          }
        }
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.prepareChess(nextProps);
  }

  componentWillUnmount() {
    const { setPrevLocation, location } = this.props;
    setPrevLocation(location.search);

    document.body.classList.remove('chess');
  }

  parseQuery(query) {
    if (this.props.print) {
      return this.props.queryParams || {};
    }
    const {
      section,
      table,
      sort,
      cell,
      priceMin,
      priceMax,
      costMin,
      costMax,
      areaFrom,
      areaTo,
      interior,
      view_type,
    } = parseQuery(query);
    const selectedSectionKey = section || null;
    const selectedSectionPath = selectedSectionKey
      ? selectedSectionKey.split('.').map((value) => Number(value))
      : null;
    let isTable, isExtended;
    switch (table) {
      case 'common':
        isTable = true;
        isExtended = false;
        break;
      case 'extended':
        isTable = true;
        isExtended = true;
        break;
      case 'list':
        isTable = false;
        isExtended = false;
        break;
      default:
        isTable = null;
        isExtended = null;
    }
    let listSortPath = null;
    if (sort) {
      const [column, direction] = sort.split(':');
      listSortPath = [column, direction !== 'desc'];
    }
    const selectedCelllPath = cell ? cell.split('.').map((value) => Number(value)) : null;

    const {
      building: {
        isTable: prevIsTable,
        isExtended: prevIsExtended,
        selected: prevSelected,
        filters: prevFilters,
        filters: { section: prevSelectedSectionPath },
        listSort: prevListSort,
      },
    } = this.props;
    const prevSelectedSectionKey = prevSelectedSectionPath.join('.');

    return {
      isTable: this.props.client ? false : isTable != null ? isTable : prevIsTable,
      isExtended: isExtended != null ? isExtended : prevIsExtended,
      selected:
        selectedCelllPath != null
          ? {
              ...prevSelected,
              [selectedSectionKey != null ? selectedSectionKey : prevSelectedSectionKey]:
                selectedCelllPath,
            }
          : prevSelected,
      filters: {
        ...prevFilters,
        section: selectedSectionPath != null ? selectedSectionPath : prevSelectedSectionPath,
        priceMin,
        priceMax,
        costMin,
        costMax,
        areaFrom,
        areaTo,
        interior,
        view_type,
      },
      listSort: listSortPath != null ? listSortPath : prevListSort,
    };
  }

  transitionTo(queryParams) {
    const { history, location } = this.props;
    const path = this.getPath(queryParams);
    const [, search] = path.split('?');

    if (location.search && location.search.length > 1 && location.search.slice(1) === search) {
      return;
    }

    history.push(path);
  }

  getPath(queryParams) {
    const { match, client, print, location } = this.props;
    const { params } = match;
    const query = compileQuery(queryParams, location.search);
    const search = query ? `?${query}` : '';
    if (client) {
      return `/view/${params.referal}/building/${params.id}${search}`;
    }
    if (print) {
      return `/print/${params.id}${search}`;
    }
    return `/building/${params.id}/chess${search}`;
  }

  getData(rows, cols, cells, t) {
    const rowLength = rows.length;
    const colLength = cols.reduce((prev, cur) => prev + (Number(cur.colspan) || 1), 0);
    const data = Array(rowLength)
      .fill(null)
      .map(() => ({ cells: Array(colLength) }));

    let selected, imagelessSelected, soldSelected;

    cells.forEach((cell, index) => {
      let { row, col, rowspan, colspan } = cell;

      row = Number(row);
      col = Number(col);

      if (row > rowLength - 1 || col > colLength - 1) {
        throw new Error(`Ячейка под индексом ${index} ссылается на неизвестный row или col`);
      }
      if (data[row].cells[col] !== undefined) {
        return;
      }

      colspan = !colspan || colspan === '0' ? 1 : Number(colspan);
      rowspan = !rowspan || rowspan === '0' ? 1 : Number(rowspan);

      if (rowspan > 1 || colspan > 1) {
        for (let rowKey = row; rowKey < row + rowspan; ++rowKey) {
          if (rowKey > rowLength - 1) {
            throw new Error(
              `Ячейка под индексом ${index} слишком высокая и выходит за пределы таблицы`
            );
          }
          for (let colKey = col; colKey < col + colspan; ++colKey) {
            if (colKey > colLength - 1) {
              throw new Error(
                `Ячейка под индексом ${index} слишком широкая и выходит за пределы таблицы`
              );
            }
            data[rowKey].cells[colKey] = null;
          }
        }
      }

      if (cell.data.disabled) {
        data[row].cells[col] = null;
        return;
      }

      const interiors = getInteriors(t);
      const floorName = rows[cell.row].name;
      const interiorName = interiors[cell.data.interior];
      const apartments = getApartments(t);
      const apartmentsName = apartments[cell.data.cnt_apart];
      const priceFormatted = formatNumber(cell.data.priceM);
      const costFormatted = formatNumber(cell.data.priceAll);
      const hidden =
        ['soldStatus', '0'].includes(cell.data.status) ||
        (!cell.data.area && !['fundStatus'].includes(cell.data.status));

      const room = {
        ...cell,
        data: {
          ...cell.data,
          interiorName,
          floorName,
          apartmentsName,
          priceFormatted,
          costFormatted,
        },
        row,
        col,
        rowspan,
        colspan,
        hidden,
      };
      room.content = {
        common: hidden ? null : this.getCellContent(room),
        extended: hidden ? null : this.getCellExtendedContent(room),
      };

      data[row].cells[col] = room;

      if (!selected) {
        if (room.planId && !room.hidden) {
          selected = [row, col];
        } else if (!imagelessSelected) {
          if (!room.hidden) {
            imagelessSelected = [row, col];
          } else if (!soldSelected) {
            soldSelected = [row, col];
          }
        }
      }
    });

    return { data, selected: selected || imagelessSelected || soldSelected || null };
  }

  getCellContent(room) {
    return room.data.area;
  }

  getCellExtendedContent(room) {
    const reservation = isReserved(room.data.status);
    if (this.props.print) {
      return (
        <div
          className={cn(
            styles.ExtendedContent,
            { [styles.Reservation]: reservation },
            styles.ExtendedContentPrint
          )}
        >
          <div className={styles.ExtendedContentLeft}>
            <p>
              <span className={styles.PrintExtendedEmptySpan}>{room.data.number}</span>
            </p>
            <p>
              <span>{room.data.area}</span>
            </p>
          </div>
          <div className={styles.ExtendedContentRight}>
            <p>
              <span>{room.data.costFormatted}</span>
            </p>
            <p>
              <span>{room.data.priceFormatted}</span>
            </p>
          </div>
        </div>
      );
    }
    return (
      <div
        className={cn(
          styles.ExtendedContent,
          { [styles.Reservation]: reservation },
          { [styles.NotMatch]: !room.mark }
        )}
      >
        <div className={styles.ExtendedContentLeft}>
          <p>
            <span className={styles.ExtendedFlatNum}>{`№${room.data.number}`}</span>
          </p>
          {room.data.apartmentsName ? (
            <p>
              <span>{room.data.apartmentsName}</span>
            </p>
          ) : null}
        </div>
        <div className={styles.ExtendedContentRight}>
          {room.data.costFormatted && room.data.costFormatted == 0 ? null : (
            <p>
              <span className={styles.ExtendedFlatPrice}>{room.data.costFormatted}</span>
            </p>
          )}
          <p>
            <span>
              {room.data.area}
              {room.data.priceFormatted == 0 ? null : (
                <span className={styles.Span}>, {room.data.priceFormatted}</span>
              )}
            </span>
          </p>
        </div>
      </div>
    );
  }

  handleFilters(update = {}) {
    const {
      building: { selected },
    } = this.props;
    const { section: selectedSectionPath, prevSection } = update;
    if (selectedSectionPath) {
      const selectedSectionKey = selectedSectionPath.join('.');
      const selectedCellPath = selected[selectedSectionKey];
      const selectedCellKey = selectedCellPath ? selectedCellPath.join('.') : null;
      this.prevSection = prevSection;
      this.transitionTo({ section: selectedSectionKey, cell: selectedCellKey });
    }
  }

  handleListClick(isTable) {
    let table,
      sort = null;
    if (isTable) {
      const {
        building: { isExtended },
      } = this.props;
      table = isExtended ? 'extended' : 'common';
    } else {
      const {
        building: { listSort },
      } = this.props;
      table = 'list';
      sort = [listSort[0], listSort[1] ? 'asc' : 'desc'].join(':');
    }
    this.transitionTo({ table, sort });
  }

  handleExtendedClick() {
    const {
      building: { isExtended, data },
    } = this.props;
    const table = isExtended ? 'common' : 'extended';

    const { id, title } = this.props.building.data;

    tracker.sendEvent('Web_List_Filters_Extended_Activation', {
      id,
      name: title,
      selected: !isExtended,
    });

    this.handleTrackEvent({
      eventName: 'buildingChessFiltersClick',
      eventContent: 'rasshirennaya_shahmatka',
    });

    this.transitionTo({ table });
  }

  handleTrackEvent = ({ eventName, eventContent }) => {
    const { profile, objectType, building, isTable } = this.props;
    const { title, id } = building.data;
    trackGA(
      gaEvent[eventName]({
        eventContent,
        eventContext: isTable ? 'shahmatka' : 'spisok',
        productType: objectType,
        productName: title,
        productID: id,
        user_id: profile.id,
      })
    );
  };

  handleListSort(col, dir) {
    const sort = [col, dir ? 'asc' : 'desc'].join(':');
    this.transitionTo({ sort });
  }

  handleCellClick = (id, selected) => {
    const cell = selected.join('.');
    this.transitionTo({ cell });
  };

  handleFloorClick = (selected) => {
    this.handleCellClick(null, selected);
  };

  handleTableScroll(id, scrollTop, scrollLeft) {
    const { setTableScroll } = this.props;
    setTableScroll(id, [scrollTop, scrollLeft]);
  }
  toggleSidebar() {
    this.setState({ isSidebarHidden: !this.state.isSidebarHidden });
  }

  zoomIn = () => {
    this.handleTrackEvent({
      eventName: 'buildingChessFiltersClick',
      eventContent: 'uvelichit',
    });

    this.props.setZoom({ zoom: 1 });
  };

  zoomOut = () => {
    this.handleTrackEvent({
      eventName: 'buildingChessFiltersClick',
      eventContent: 'umenshit',
    });

    this.props.setZoom({ zoom: -1 });
  };

  handleZoomChange = (e) => {
    this.props.setZoom({
      zoomWithRange: true,
      zoom: +e.target.value,
    });
  };

  handleZoomMouseDown = (e) => {
    e.stopPropagation();
  };

  render() {
    const {
      client,
      location,
      page,
      pageSize,
      isObjectsFetching,
      isBuildingLoading,
      building: {
        data: building,
        pavilions: pavilionsFlat,
        chessList,
        filters,
        cells,
        selected,
        isTable,
        isExtended,
        listSort,
        tableScroll,
        isDescriptionHide,
        isLoading,
        isChessLoading,
      },
      zoom,
      setZoom,
      t,
      currency,
      profile,
      objectType,
    } = this.props;

    if (isObjectsFetching || isLoading || isBuildingLoading) return null;

    const { isSidebarHidden } = this.state;
    const { section: selectedSectionPath } = filters;
    let sectionCells = null;
    let chess = null;
    let sectionId;
    let selectedSectionKey;
    let selectedCellPath;
    let selectedCell;
    let scrollKey;
    let defaultScroll = [0, 0];
    let sortKey;

    if (building && pavilionsFlat) {
      selectedSectionKey = selectedSectionPath.join('.');
      selectedSectionKey =
        cells[selectedSectionKey] || !this.prevSection
          ? selectedSectionKey
          : this.prevSection.join('.');
      sectionCells = cells[selectedSectionKey];

      if (sectionCells) {
        const [pavilionIndex, sectionIndex] = cells[selectedSectionPath.join('.')]
          ? selectedSectionPath
          : this.prevSection;
        sectionId = pavilionsFlat[pavilionIndex].sections[sectionIndex].id;
        const chessRaw = chessList[sectionId];
        const cols = chessRaw.cols.reduce((prev, cur) => {
          let { colspan } = cur;
          colspan = Number(colspan) || 1;
          const cols = Array(colspan).fill(null);
          cols[0] = cur;
          return prev.concat(cols);
        }, []);
        chess = { ...chessRaw, cols };
        selectedCellPath = selected[selectedSectionKey];
        const [row, column] = selectedCellPath;
        selectedCell = selectedCellPath ? sectionCells[row].cells[column] : null;
        scrollKey = [pavilionIndex, sectionIndex, isTable, isTable ? isExtended : null]
          .filter((value) => value != null)
          .join('.');
        sortKey = listSort.join('.');
        defaultScroll = tableScroll[scrollKey] || [0, 0];
        this.dataFlats = this.dataFlats !== undefined ? this.dataFlats : building.count_flats;
      }
    }
    const print = this.props.print;

    const isDataFlatsExists =
      this.dataFlats !== undefined ? !!this.dataFlats : !isChessLoading && !!this.dataFlats;
    const { id, title } = building;

    return building ? (
      <React.Fragment>
        <Helmet>
          <title>{t('components.building.chess.title', { building: building.title })}</title>
        </Helmet>
        <div className={cn(styles.Building, { [styles.BuildingPrint]: print })}>
          <div className={styles.LandscapeOverlay}></div>
          {!client && (
            <BuildingBar
              className={styles.BuildingBar}
              location={location}
              isTable={isTable}
              print={print}
              handleList={this.handleListClick}
              pavilions={building.pavilions}
              pavilionsFlat={pavilionsFlat}
              filters={filters}
              handleFilters={this.handleFilters}
              profile={profile}
              buildingData={building}
              objectType={objectType}
            />
          )}
          <div
            className={cn(client ? styles.ContainerClient : styles.Container, {
              [styles.DescriptionHide]: isDescriptionHide,
            })}
          >
            <Loader active={isLoading || isChessLoading} />
            <div className={cn(styles.TableWrap, { [styles.Wide]: isSidebarHidden })}>
              <div className={cn(styles.FiltersBarWrap, { [styles.Client]: client })}>
                <div className={cn(styles.FiltersBar, { [styles.Client]: client })}>
                  {sectionCells ? (
                    <div className={cn(styles.Filters, styles.FiltersBBB)}>
                      <Filters
                        pavilions={building.pavilions}
                        pavilionsFlat={pavilionsFlat}
                        filters={filters}
                        print={print}
                        handleFilters={this.handleFilters}
                        search={filters}
                        cells={chess.cells}
                        eventData={{
                          id,
                          name: title,
                        }}
                        currency={currency}
                        profile={profile}
                        buildingData={building}
                        objectType={objectType}
                        isTable={isTable}
                      />
                    </div>
                  ) : (
                    <div className={styles.WireframeFilters} />
                  )}
                  {sectionCells ? (
                    <TableOptions
                      className={cn(styles.TableOptions, { [styles.Client]: client })}
                      isTable={isTable}
                      isExtended={isExtended}
                      handleList={this.handleListClick}
                      handleExtended={this.handleExtendedClick}
                      client={client}
                    />
                  ) : (
                    <div className={styles.WireframeTableOptions}>
                      <div className={styles.WireframeTableOptionsCheck} />
                    </div>
                  )}
                  {sectionCells && isTable ? (
                    <div className={styles.ZoomButtons}>
                      <div onClick={this.zoomOut} className={cn(styles.ZoomBtn, styles.ZoomOut)} />
                      <input
                        type="range"
                        step={0.25}
                        value={zoom}
                        min={MIN_SCALE}
                        max={MAX_SCALE}
                        onChange={this.handleZoomChange}
                        onMouseDown={this.handleZoomMouseDown}
                      />
                      <div onClick={this.zoomIn} className={cn(styles.ZoomBtn, styles.ZoomIn)} />
                    </div>
                  ) : null}
                </div>
              </div>
              <div className={styles.Table}>
                {sectionCells ? (
                  isTable ? (
                    <Table
                      cells={chess.cells}
                      print={print}
                      client={client}
                      key={scrollKey}
                      cols={chess.cols || []}
                      rows={chess.rows || []}
                      page={page || 0}
                      pageSize={pageSize || Number.MAX_SAFE_INTEGER}
                      data={sectionCells}
                      selected={selectedCellPath}
                      building={building}
                      content={isExtended ? 'extended' : 'common'}
                      wide={isExtended}
                      zoom={zoom}
                      setZoom={setZoom}
                      defaultScroll={defaultScroll}
                      handleCellClick={this.handleCellClick.bind(undefined, selectedSectionKey)}
                      handleScroll={this.handleTableScroll.bind(undefined, scrollKey)}
                      objectType={objectType}
                      profile={profile}
                    />
                  ) : (
                    <List
                      typeId={building.type_id}
                      cells={chess.cells}
                      client={client}
                      key={scrollKey + sortKey}
                      data={sectionCells}
                      selected={selectedCellPath}
                      sortColumn={listSort}
                      defaultScroll={defaultScroll}
                      handleCellClick={this.handleCellClick.bind(undefined, selectedSectionKey)}
                      handleSort={this.handleListSort}
                      handleScroll={this.handleTableScroll.bind(undefined, scrollKey)}
                      isSidebarHidden={isSidebarHidden}
                      isDataFlatsExists={isDataFlatsExists}
                      isChessLoading={isChessLoading}
                      objectType={objectType}
                      profile={profile}
                      building={building}
                      pavilions={building.pavilions}
                      location={location}
                    />
                  )
                ) : null}
              </div>
            </div>
            <div className={cn(styles.Description, { [styles.Hidden]: isSidebarHidden })}>
              <div className={styles.CollapseDescriptionBtn} onClick={this.toggleSidebar}>
                <img src={IconRight} alt="" />
              </div>
              <div className={cn(styles.DescriptionContent, { [styles.Client]: client })}>
                {sectionCells ? (
                  <RightMenu
                    handleCellClick={this.handleCellClick}
                    building={building}
                    data={selectedCell}
                    sectionCells={sectionCells}
                    rows={chess.rows}
                    selectedCellPath={selectedCellPath}
                    sectionId={sectionId}
                    client={client}
                    filters={filters}
                    pavilionsFlat={pavilionsFlat}
                    handleFilters={this.handleFilters}
                    isChessLoading={isChessLoading}
                    cells={chess.cells}
                    objectType={objectType}
                    profile={profile}
                    building={building}
                    isTable={isTable}
                  />
                ) : (
                  <div className={styles.WireframeRightMenu}>
                    <div className={styles.WireframeAbout}>
                      <div className={styles.WireframeRow}>
                        <div className={styles.WireframeImage} />
                      </div>
                      <div className={styles.WireframeRow}>
                        <div className={styles.WireframeFirstSpan}>
                          <div className={styles.WireframeNum} />
                          <div className={styles.WireframePrintBtn} />
                        </div>
                        <div className={styles.WireframeSecondSpan} />
                        <div className={styles.WireframeThirdSpan} />
                        <div className={styles.WireframeFourthSpan} />
                      </div>
                    </div>
                    <div className={styles.WireframeGallery}>
                      <div className={styles.WireframeRow}>
                        <div className={styles.WireframeFirstSpan} />
                      </div>
                      <div className={styles.WireframeRow}>
                        <div className={styles.WireframeImage} />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    ) : null;
  }
}

const mapStateToProps = (state) => ({
  isObjectsFetching: state.objects.isObjectsFetching,
  zoom: state.building.zoom,
  currency: state.profile.user_region.country_currency_symbol,
  objectType: state.building.data && state.building.data.type_id == 1 ? 'zhk' : 'kp_i_th',
  profile: state.profile,
});

export default withTranslation()(
  connect(mapStateToProps, {
    loadBuilding,
    loadPavilions,
    loadChess,
    setCells,
    setFilters,
    setZoom,
    setChessTable,
    setChessExtended,
    setChessDescriptionHide,
    setListSort,
    setTableScroll,
    setSelected,
    setPrevLocation,
    updateChessState,
  })(withRouter(Chess))
);



// WEBPACK FOOTER //
// ./src/components/Building/Chess/Chess.js